import React, { CSSProperties } from 'react';
import useTheme from '@material-ui/core/styles/useTheme';
import { useMediaQuery } from '@material-ui/core';

import { FsComponentSize } from 'globals/types';
import {
  getContainerStyle,
  getDescriptionStyle,
  getInfoBoxStyle,
  getValueStyle,
  getWrapWordsStyle,
} from './FsSingleBarGraph.style';
import {
  BarContainer,
  BarPointer,
  ContainerBox,
  Description,
  InfoBox,
  Line,
  Title,
  Value,
} from './FsSingleBarGraph.style-elements';

export interface FsSingleBarGraphDataProps {
  maxValue?: number;
  value?: number | string;
  title?: string;
  description?: string;
  barValue?: number;
}

export interface FsSingleBarGraphProps extends FsSingleBarGraphDataProps {
  barWidth?: number;
  barHeight?: number;
  barColor?: string;
  valueSize?: FsComponentSize.M | FsComponentSize.L;
  descriptionSize?: FsComponentSize.M | FsComponentSize.L;
  wrapWords?: boolean;
  infoBoxWidth?: number;
  style?: CSSProperties;
  isLastElement: boolean;
}

const FsSingleBarGraph: React.FC<FsSingleBarGraphProps> = ({
  barWidth = 32,
  barHeight = 100,
  barValue = 50,
  barColor,
  title,
  value = 'value',
  valueSize = FsComponentSize.M,
  description = 'description',
  descriptionSize = FsComponentSize.M,
  wrapWords = true,
  infoBoxWidth,
  style,
  isLastElement,
}) => {
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const valueStyle = getValueStyle(valueSize);
  const descriptionStyle = getDescriptionStyle(descriptionSize);
  const wrapWordsStyle = getWrapWordsStyle({ wrapWords, isUpSm });
  const infoBoxStyle = getInfoBoxStyle({ infoBoxWidth, isUpSm });
  const containerStyle = getContainerStyle({ theme, isUpSm, isLastElement });

  return (
    <ContainerBox style={{ ...containerStyle, ...style }}>
      <BarContainer
        width={`${barWidth}px`}
        minWidth={`${barWidth}px`}
        height={`${barHeight}px`}
      >
        <BarPointer height={`${barValue}%`} bgcolor={barColor} />
      </BarContainer>
      <InfoBox style={infoBoxStyle}>
        {title && <Title style={wrapWordsStyle}>{title}</Title>}
        {title && <Line />}
        {value && <Value style={valueStyle}>{value}</Value>}
        {description && (
          <Description style={{ ...wrapWordsStyle, ...descriptionStyle }}>
            {description}
          </Description>
        )}
      </InfoBox>
    </ContainerBox>
  );
};

export default FsSingleBarGraph;
